import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/focus-fix.css'; // 修复焦点样式问题

// 国际化配置
import './i18n/config';

// Monaco Editor CDN 配置（解决 jsdelivr 超时问题）
import './config/monacoConfig';

// 主题配置 - 修改 theme.ts 中的 CURRENT_THEME 切换主题
import { applyTheme } from './config/theme';
import { applyBrandingTheme } from './config/branding';
applyTheme();
applyBrandingTheme();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
